import React from "react";
import {
    Space,
    Row,
    Col,
    message,
    Image,
    Button,
    Modal,
    Tooltip,
    Drawer,
    Input,
    Tabs,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";

import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyStore from "../store/CompanyStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import TicketAdd from "./TicketAdd";
import TicketStore from "../store/TicketStore";
import dayjs from "dayjs";


class TicketList extends React.Component {
    constructor(props, context) {
        super(props);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.companyStore = new CompanyStore();
        this.ticketStore = new TicketStore(this)

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            companyVal_Lab: "",
            openInspectionForm: false,
            inspectionId: "",
            listDataUpdate: false,
            openDeleteModal: false,
            deleteData: {},
            editData: {},
            openTicketForm: false,
            searchField: ''
            // openActionTakenPopup: false
        };

        this.columns = [
            {
                title: context.translate("_TICKET_ID_"),
                dataIndex: "ticketId",
                width: 8,
                ellipsis: {
                    showTitle: true,
                },
                render: (value, record) => {

                    const isadmin = Number(this.props.getUserData().isadmin);

                    // isadmin = -1 -> edit all
                    // isadmin = 1 -> edit only record.value == 1
                    const canEdit =
                        (
                            isadmin == -1 ||
                            isadmin == 3
                        ) &&
                        record.ticketStatus != 4 &&
                        record.ticketStatus != 5
                        ||
                        (
                            isadmin == 1 &&
                            record.ticketStatus == 1
                        );

                    return canEdit ? (
                        <Link
                            style={{
                                color: "#2563EB",
                                textDecoration: "none"
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                this.onEdit(record);
                            }}
                        >
                            {value}
                        </Link>
                    ) : (
                        <span>{value}</span>
                    );
                },
            },
            {
                title: context.translate("_REQUEST_TYPE_"),
                dataIndex: "ticketType",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (val) => {
                    if (val === 1) {
                        return "Existing Issue"
                    } else if (val === 2) {
                        return "New Installation"
                    }
                }
            },
            {
                title: context.translate("_TYPE_"),
                dataIndex: "comment",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PRIORITY_"),
                dataIndex: "priority",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    if (value === 1) {
                        return <div className="ticketList-priority-type-low">Low</div>;
                    } else if (value === 2) {
                        return <div className="ticketList-priority-type-medium">Medium</div>;
                    } else if (value === 3) {
                        return <div className="ticketList-priority-type-high">High</div>;
                    }
                }

            },
            {
                title: context.translate("_STATUS_"),
                dataIndex: "ticketStatus",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    if (value === 1) {
                        return <div className="ticketList-status-type-open">Open</div>;
                    } else if (value === 2) {
                        return <div className="ticketList-status-type-inProgress">In Progress</div>;
                    } else if (value === 3) {
                        return <div className="ticketList-status-type-onHold">On Hold</div>;
                    } else if (value === 4) {
                        return <div className="ticketList-status-type-resolved">Resolved</div>;
                    } else if (value === 5) {
                        return <div className="ticketList-status-type-closed">Closed</div>;
                    }
                }
            },
            {
                title: context.translate("_RAISED_BY_"),
                dataIndex: "name",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_RAISED_ON_"),
                dataIndex: "date",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (val) => {
                    if (val) {
                        return dayjs(val).format("DD-MM-YYYY");
                    } else {
                        return <></>
                    }
                }
            },
            {
                title: context.translate("_LAST_UPDATED_"),
                dataIndex: "updatedByDate",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (val) => {
                    if (val) {
                        return dayjs(val).format("DD-MM-YYYY");
                    } else {
                        return <></>
                    }
                }
            },
            ...(
                Number(this.props.getUserData().isadmin) !== -1 &&
                    Number(this.props.getUserData().isadmin) !== 3
                    ? [{
                        title: context.translate("_ACTION_TAKEN_"),
                        dataIndex: "actiontaken",
                        width: 10,
                        ellipsis: {
                            showTitle: true,
                        },
                        align: "center",
                        render: (_, record) => {
                            // return (
                            //     <>
                            //         <Tooltip title={record.actionTaken}>
                            //             <CheckCircleOutlined
                            //                 style={{
                            //                     color: "#52c41a",
                            //                     fontSize: "20px",
                            //                     cursor: "pointer"
                            //                 }}
                            //                 onClick={() => {
                            //                     this.setState({
                            //                         openActionTakenPopup: true
                            //                     });
                            //                 }}
                            //             />
                            //         </Tooltip>
                            //     </>
                            // );
                            return (
                                <Tooltip
                                    title={
                                        <Input.TextArea
                                            value={record.actionTaken}
                                            autoSize={{ minRows: 3, maxRows: 6 }}
                                            readOnly
                                            style={{
                                                resize: "none",
                                                width: "250px",
                                                color: "black"
                                            }}
                                        />
                                    }
                                    color="#fff"
                                >
                                    <CheckCircleOutlined
                                        style={{
                                            color: "#52c41a",
                                            fontSize: "20px",
                                            cursor: "pointer"
                                        }}
                                    />
                                </Tooltip>
                            );
                        }
                    }]
                    : []
            ),
            // {
            //     // title: "Action",
            //     title: context.translate("_ACTION_"),
            //     dataIndex: "action",
            //     ellipsis: {
            //         showTitle: true,
            //     },
            //     align: "center",
            //     width: 5,
            //     render: (_, record) => {
            //         return (
            //             <>
            //                 <Image
            //                     style={{ cursor: "pointer", width: "6px" }}
            //                     src={kebabIcon}
            //                     onClick={(e) => {
            //                         e.preventDefault();
            //                     }}
            //                 ></Image>
            //             </>
            //         );
            //     },
            // },
        ];

    }

    getFilteredData = (status) => {
        let data = this.ticketStore.ticketDetails || [];

        if (status !== "All") {
            data = data.filter(
                (item) => item.ticketStatus === status
            );
        }

        if (this.state.searchField) {
            const search = this.state.searchField.toLowerCase();

            data = data.filter((item) =>
                item.comment?.toLowerCase().includes(search) ||
                item.ticketId?.toString().toLowerCase().includes(search)
                // item.ticketType?.toLowerCase().includes(search)
            );
        }

        return data;
    };

    async componentDidMount() {
        await this.handleSearch();
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            // await this.handleSearch();
            this.setState({ loadData: 1 })
        }

        this.setState({ pageSize: 50, loadData: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }

    async handleSearch() {
        const isadmin = this.props.getUserData().isadmin
        const usercompanyId = this.props.getUserData().userCompanyId
        const addedByUserId = this.props.getUserData().userId
        await this.ticketStore.getTicketData({
            isadmin: isadmin,
            usercompanyId: usercompanyId,
            addedByUserId: addedByUserId,
            offset: 0,
            limit: 50,
        });
        await this.setState({ loadData: 1 });
    }

    onEdit = async (record) => {
        await this.setState({ ticketId: record.ticketId });
        await this.setState({ openTicketForm: true });
    };

    onDelete = async (record) => {
        const response = await this.inspectionStore.deleteRecord({
            ins_Id: record.ins_Id,
            companyId: record.companyId,
        });

        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.setState({ openDeleteModal: false });
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    };

    responseMsg = async (resp) => {
        if (resp.success == "S") {
            message.success(resp.message);
            await this.setState({ openTicketForm: false });

            await this.handleSearch();
        } else {
            message.error(resp.message);
        }
    };

    closeModal = () => {
        this.setState({ openTicketForm: false, ticketId: "" });
    };

    refreshList = async () => {
        this.setState({ loading: true });
        const isadmin = this.props.getUserData().isadmin
        const usercompanyId = this.props.getUserData().userCompanyId
        const addedByUserId = this.props.getUserData().userId
        await this.ticketStore.getTicketData({
            isadmin: isadmin,
            usercompanyId: usercompanyId,
            addedByUserId: addedByUserId,
            offset: 0,
            limit: 50,
        });

        this.setState({ loadData: 1, loading: false, currentPage: 1 });
    };

    render() {
        const isadminCondition = Number(this.props.getUserData().isadmin) !== -1 && Number(this.props.getUserData().isadmin) !== 3

        this.tabItems = [
            {
                key: '1',
                label: 'All Tickets',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={this.getFilteredData("All")}
                        // dataSource={this.ticketStore.ticketDetails}
                        ticketListcls="ticketListcls"
                    />

                )
            },
            {
                key: '2',
                label: 'Open',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={this.getFilteredData(1)}
                        ticketListcls="ticketListcls"
                    />
                ),
            },
            {
                key: '3',
                label: 'In Progress',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={this.getFilteredData(2)}
                        ticketListcls="ticketListcls"
                    />
                ),

            },
            {
                key: '4',
                label: 'On Hold',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={this.getFilteredData(3)}
                        ticketListcls="ticketListcls"
                    />
                ),
            },
            {
                key: '5',
                label: 'Resolved',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={this.getFilteredData(4)}
                        ticketListcls="ticketListcls"
                    />
                ),
            },
            {
                key: '6',
                label: 'Closed',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={this.getFilteredData(5)}
                        ticketListcls="ticketListcls"
                    />
                ),
            },
        ];
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <Input onChange={async (e) => {
                                    this.setState({ searchField: e.target.value })
                                    const value = e.target.value;

                                    await this.setState({
                                        searchField: value
                                    });

                                    // search after 3 characters
                                    // if (value.length > 3 || value.length === 0) {
                                    //     this.handleSearch();
                                    // }
                                }} placeholder={"Search"} style={{ borderRadius: "40px", width: "250px" }} />
                            </Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={8}
                        >
                            {/* <Button onClick={() => {
                                this.props.navigate("/ticketDetails");
                            }}>
                                {this.context.translate("_TICKET_LOG_DETAILS_")}
                            </Button> */}

                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        marginInlineEnd: "20px",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>

                            {isadminCondition && <Button
                                className="addButtonClass"
                                onClick={() =>
                                    this.setState({ openTicketForm: true, ticketId: "" })
                                }
                            >
                                <Image
                                    style={{ width: 13, marginInlineEnd: "5px" }} //marginInlineEnd: "5px",
                                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                ></Image>
                                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                            </Button>}
                        </Col>
                    </Row>
                    <Tabs className="ticketTabs" defaultActiveKey="1" items={this.tabItems} />

                </div>

                {this.state.openTicketForm && (

                    <Drawer
                        className="uploadExcelDrawer"
                        width={716}
                        closeIcon={false}
                        open={this.state.openTicketForm}
                        footer={false}
                        placement={

                            this.context.locale.language === "arabic" ? "left" : "right"

                        }
                        title={
                            <div className="formTitle">
                                {this.context.translate("_TICKET_DETAILS_")}
                                <p className="formDescription">
                                    {this.context.translate("_TICKET_DETAILS_DESC_")}
                                </p>
                            </div>
                        }
                        maskClosable={false}
                        onOk={() => this.setState({ openTicketForm: false })}
                        onCancel={() =>
                            this.setState({ openTicketForm: false, ticketId: "" })
                        }
                    >
                        <div style={{ height: "100%" }}>
                            <TicketAdd
                                ticketId={this.state.ticketId}
                                response={this.responseMsg}
                                closeModal={this.closeModal}
                            />
                        </div>
                    </Drawer>
                )}
                {this.state.openDeleteModal && (
                    <Modal
                        maskClosable={false}
                        title={
                            <div className="deleteModalTitle">
                                <span>
                                    {" "}
                                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                                </span>
                                <CloseOutlined
                                    style={{ cursor: "pointer", color: "white" }}
                                    onClick={() => this.setState({ openDeleteModal: false })}
                                />
                            </div>
                        }
                        className="deleteModal"
                        description="Are you sure you want to delete this Item? This action cannot be undone."
                        centered
                        open={this.state.openDeleteModal}
                        footer={null}
                        width={400}
                        closable={false}
                    >
                        <div className="deleteModalText">
                            <p>{this.context.translate("_DELETE_STATUS_")}</p>
                        </div>
                        <div className="deleteModalButtons">
                            <Button
                                className="deleteModalCancelButton"
                                onClick={() => this.setState({ openDeleteModal: false })}
                            >
                                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>

                            <Button
                                className="deleteModalOkButton"
                                onClick={() => this.onDelete(this.state.deleteData)}
                            >
                                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                            </Button>
                        </div>
                    </Modal>
                )}


            </>
        );
    }
}
TicketList.contextType = StoreContext;
export default observer(withRouter(TicketList));
